import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20l16 -16","key":"svg-0"}],["path",{"d":"M13 4h7v7","key":"svg-1"}],["path",{"d":"M6.5 12.5l5 5","key":"svg-2"}]]

/**
 * IconZodiacSagittarius
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9kaWFjLXNhZ2l0dGFyaXVzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDIwbDE2IC0xNiIgLz4KICA8cGF0aCBkPSJNMTMgNGg3djciIC8+CiAgPHBhdGggZD0iTTYuNSAxMi41bDUgNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/zodiac-sagittarius
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZodiacSagittarius = createReactComponent('outline', 'zodiac-sagittarius', 'ZodiacSagittarius', __iconNode);

export default IconZodiacSagittarius;